/** Default fallback timezone used when an org has no reportTimezone or an invalid one. */
export const DEFAULT_TIMEZONE = 'Australia/Sydney' as const;

export const IANA_TIMEZONE = [
    'Australia/Sydney',
    'Australia/Hobart',
    'Australia/Melbourne',
    'Australia/Brisbane',
    'Australia/Adelaide',
    'Australia/Darwin',
    'Australia/Perth',
] as const;
